
import Vue from "vue";

import TextFieldCopier from "./TextFieldCopier.vue";

export default Vue.extend({
  name: "VerifyScreen",
  props: {
    setStep: {
      type: Function,
    },
    finalHash: {
      type: String,
    },
    finalSig: {
      type: String,
    },
    finalSigner: {
      type: String,
    },
  },
  components: {
    TextFieldCopier,
  },
  data: () => ({
    copied: false,
    verified: false,
  }),
  methods: {
    copyToClipboard() {
      this.copied = true;
      setTimeout(() => {
        this.copied = false;
      }, 3000);
    },
    confirmVerification() {
      this.verified = true;
      this.setStep(4);
    },
  },
});
